import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

import { CardComponent } from '../card/card.component';

@Component({
  selector: 'lyceo-single-card-layout',
  templateUrl: './single-card-layout.component.html',
  styleUrls: ['./single-card-layout.component.scss'],
  imports: [CardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleCardLayoutComponent {
  public logo: InputSignal<boolean> = input(false);
}
